export default __webpack_public_path__ + "static/media/1976.a26f639f.png";